// Тактильный отклик: на телефоне ход «ощущается». Там, где вибрации нет (десктоп, iOS Safari), тихо ничего не делает.
export type HapticKind = 'tap' | 'good' | 'miss' | 'boom' | 'win';

/** navigator.vibrate нет в lib.dom (это API Chromium), поэтому описываем нужную часть сами. */
export interface Vibrator {
  vibrate?: (pattern: number | number[]) => boolean;
}

const PATTERNS: Record<HapticKind, number | number[]> = {
  tap: 8,
  good: [14, 40, 22],
  miss: [40, 30, 40],
  boom: [70, 40, 130, 40, 220],
  win: [18, 60, 18, 60, 60],
};

export function haptic(
  kind: HapticKind,
  nav: Vibrator | undefined = typeof navigator === 'undefined' ? undefined : (navigator as Vibrator),
): void {
  try {
    nav?.vibrate?.(PATTERNS[kind]);
  } catch {
    // вибрация — украшение; сбой не должен ломать ход
  }
}
